import http from '@/http'

const getActive = ({ perPage = 500, pageNr = 1 } = {}) => {
	const path = `permanent_points?isActive=1&itemsPerPage=${perPage}&page=${pageNr}&order[name]=asc`
	return http.get(path)
}

const find = id => {
	const path = `permanent_points/${id}`
	return http.get(path)
}

const getAll = ({
					sorting: { field, order },
					perPage = 10,
					pageNr = 1,
					searchText,
					where = []
				}) => {
	let filterSegment = ''
	let searchSegment = ''
	let whereSegment = ''



	if (where.length) {
		where.forEach(({ whereField, whereValue }) => {
			whereSegment += `&${whereField}=${whereValue}`
		})
	}

	if (searchText) searchSegment = `&search=${searchText}`

	let path = `permanent_points?order[${field}]=${order}&itemsPerPage=${perPage}&page=${pageNr}`
	//if (filterSegment) path += filterSegment
	if (searchSegment) path += searchSegment
	if (whereSegment) path += whereSegment

	return http.get(path)
}


const prepareFieldsToSave = (obj) => {
	if (
		'undefined' !== typeof obj.selectedLocation &&
		obj.selectedLocation.lat &&
		obj.selectedLocation.lon
	) {
		obj.lat = obj.selectedLocation.lat;
		obj.lon = obj.selectedLocation.lon;
	}

	return obj;
}

const create = permanentPoints => {
	const path = `permanent_points`
	const payload = prepareFieldsToSave({ ...permanentPoints })
	if (payload.creator) delete payload.creator
	return http.post(path, payload)
}

const update = permanentPoints => {
	const path 	= `permanent_points/${permanentPoints.id}`
	const payload 		= prepareFieldsToSave({ ...permanentPoints })

	if (payload.creator) delete payload.creator
	if (payload.log) delete payload.log

	return http.put(path, payload)
}

export default {
	getActive,
	getAll,
	create,
	update,
	find
}
